import * as fromViewCacheReducers from './view-cache.reducers';

import { ActionReducerMap } from '@ngrx/store';
import { AgingPeriodViewCacheStates } from '../states';

export const agingCacheReducers: ActionReducerMap<AgingPeriodViewCacheStates> = {
  agingPeriodViewCache: fromViewCacheReducers.agingCacheReducer
};
